jQuery(document).ready(function ($) {
  // Max 2 variant selection functionality
  const maxSelection = 2;
  const hasPairedProductSelect = $("#paired-product-select").length > 0;

  if (hasPairedProductSelect) {
    jQuery('.swatchInput[type="checkbox"]').change(function () {
      const $checkbox = jQuery(this);
      const selectedCheckboxes = jQuery('.swatchInput[type="checkbox"]:checked');

      if ($checkbox.is(':checked')) {
        // If trying to select more than 2, prevent selection
        if (selectedCheckboxes.length > maxSelection) {
          $checkbox.prop('checked', false);
          return false;
        }
      }
    });

    $("#paired-product-select").select2({
      templateResult: formatOption,
      templateSelection: formatOption,
      width: "100%",
    });
  }

  function formatOption(state) {
    if (!state.id) return state.text;
    var img = $(state.element).data("image");
    var price = $(state.element).data("price");
    return $(
      '<span class="cstm-item-list"><img src="' +
        img +
        '">' +
        '<div class="cstm-text">' +
        state.text +
        "<p>" +
        price +
        "</p>" +
        "</div>" +
        "</span>"
    );
  }

  if (!hasPairedProductSelect) {
    return;
  }

  jQuery('[action="/cart/add"] [type="submit"]').on("click", function () {
    var pairedId = jQuery("#paired-product-select").val();
    var pairedTitle = jQuery("#paired-product-select option:selected").attr(
      "data-title"
    );
    var mainTitle = jQuery("#paired-product-select").attr("data-product-title");

    // Handle selected variants (max 2) - match live theme logic
    var selectedCheckboxVariants = jQuery('.swatchInput[type="checkbox"]:checked');
    var selectedRadioVariants = jQuery('.swatchInput[type="radio"]:checked');
    var itemIndex = 1;

    // Clear existing variant inputs
    jQuery("#paired-variant-product").html('');

    // Only add variants as separate items if there are 2 checkbox variants selected (like live theme)
    if (selectedCheckboxVariants.length >= 2) {
      var variantValue = selectedCheckboxVariants.last().val(); // Get the last selected variant
      
      // Find the variant from the product data
      var variantsScript = document.querySelector('#variants' + jQuery('[data-section]').attr('data-section'));
      if (variantsScript) {
        var variantData = JSON.parse(variantsScript.textContent);
        var matchedVariant = variantData.find(v => v.option1 === variantValue);
        if (matchedVariant) {
          jQuery("#paired-variant-product").html(`
            <input type="hidden" name="items[${itemIndex}][id]" value="${matchedVariant.id}">
            <input type="hidden" name="items[${itemIndex}][quantity]" value="1">
            <input type="hidden" name="addon-variant-price" value="${matchedVariant.price}">
          `);
        }
      }
    }
    
    // For radio variants, the variant selection is handled by the theme's built-in variant system
    // No additional logic needed as the main product form will handle the variant ID

    // Handle paired product (chain) - use itemIndex 2 like live theme
    if (pairedId) {
      var chainItemIndex = 2;
      jQuery("#paired-product-hidden-inputs").html(`
        <input type="hidden" name="items[${chainItemIndex}][id]" value="${pairedId}">
        <input type="hidden" name="items[${chainItemIndex}][quantity]" value="1">
        <input type="hidden" name="properties[Paired Product]" value="${pairedTitle}">
        <input type="hidden" name="items[${chainItemIndex}][properties][Paired with]" value="${mainTitle}">
      `);

      if (jQuery("#paired-variant-product").html()) {
        jQuery("#paired-variant-product").append(`
          <input type="hidden" name="items[1][properties][Paired Product]" value="${pairedTitle}">
        `);
      }
    } else {
      jQuery("#paired-product-hidden-inputs").html("");
    }
  });

  $("#paired-product-select").on("select2:select", function (e) {
    updatePrice();
  });

  // Update price when variants are selected/deselected (both radio and checkbox)
  jQuery('.swatchInput[type="checkbox"], .swatchInput[type="radio"]').on('change', function() {
    updatePrice();
    updateURL();
  });

  // Listen for theme's variant change events
  document.addEventListener('variant:changed', function(event) {
    updatePrice();
    updateURL();
  });

  // Listen for variant change events from the theme's pub/sub system
  if (typeof subscribe !== 'undefined') {
    subscribe('variant-change', function(event) {
      updatePrice();
      updateURL();
    });
  }

  function updatePrice() {
    // Get base price from main-variant-price input
    var mainVariantPriceInput = jQuery('[name="main-variant-price"]');
    var updatedPrice = parseInt(mainVariantPriceInput.val()) || 0;
    
    // Add selected variants price
    var selectedCheckboxVariants = jQuery('.swatchInput[type="checkbox"]:checked');
    var selectedRadioVariants = jQuery('.swatchInput[type="radio"]:checked');
    
    // Handle checkbox variants (only if 2 or more selected)
    if (selectedCheckboxVariants.length >= 2) {
      var variantValue = selectedCheckboxVariants.last().val();
      var variantsScript = document.querySelector('#variants' + jQuery('[data-section]').attr('data-section'));
      if (variantsScript) {
        var variantData = JSON.parse(variantsScript.textContent);
        var matchedVariant = variantData.find(v => v.option1 === variantValue);
        if (matchedVariant) {
          updatedPrice += parseInt(matchedVariant.price);
        }
      }
    }
    
    // Handle radio variants (single selection updates the base price)
    if (selectedRadioVariants.length > 0) {
      var radioVariantValue = selectedRadioVariants.val();
      var variantsScript = document.querySelector('#variants' + jQuery('[data-section]').attr('data-section'));
      if (variantsScript) {
        var variantData = JSON.parse(variantsScript.textContent);
        var matchedVariant = variantData.find(v => v.option1 === radioVariantValue);
        if (matchedVariant) {
          // For radio variants, update the main variant price input and variant ID
          mainVariantPriceInput.val(matchedVariant.price);
          jQuery('input[name="id"]').val(matchedVariant.id);
          updatedPrice = parseInt(matchedVariant.price);
        }
      }
    }
    
    // Add paired product price
    updatedPrice += jQuery("#paired-product-select").val()
      ? parseInt(
          jQuery("#paired-product-select")
            .find("option:selected")
            .attr("data-raw-price")
        )
      : 0;
    
    // Update price display with multiple selectors
    var priceSelectors = [
      ".ProductMeta__PriceList .ProductMeta__Price.Price",
      ".pr_price.price-item.orpr",
      ".price .Price",
      ".product-price",
      ".price-current"
    ];
    priceSelectors.forEach(function(selector) {
      var priceElement = jQuery(selector);
      if (priceElement.length > 0) {
        priceElement.html(formatMoney(updatedPrice));
      }
    });
  }

  function updateURL() {
    // Update URL with variant parameter if variants are selected
    var selectedCheckboxVariants = jQuery('.swatchInput[type="checkbox"]:checked');
    var selectedRadioVariants = jQuery('.swatchInput[type="radio"]:checked');
    
    var variantValue = null;
    if (selectedCheckboxVariants.length > 0) {
      variantValue = selectedCheckboxVariants.last().val();
    } else if (selectedRadioVariants.length > 0) {
      variantValue = selectedRadioVariants.val();
    }
    
    if (variantValue) {
      var variantsScript = document.querySelector('#variants' + jQuery('[data-section]').attr('data-section'));
      if (variantsScript) {
        var variantData = JSON.parse(variantsScript.textContent);
        var matchedVariant = variantData.find(v => v.option1 === variantValue);
        if (matchedVariant) {
          var currentUrl = new URL(window.location);
          currentUrl.searchParams.set('variant', matchedVariant.id);
          window.history.replaceState({}, '', currentUrl);
        }
      }
    }
  }
});

function formatMoney(cents) {
  var price = (cents / 100).toFixed(2);
  return window.money_format.replace("{{amount}}", price);
}